import { mapState } from "vuex";

const GLOBAL_COMPUTED = {
  ...mapState({
    url_api: "URL_API",
    pusher_config: "PUSHER_CONFIG",
  })
};

export default GLOBAL_COMPUTED;
